export default __webpack_public_path__ + "static/media/slide1.4c170d2f.webp";